import {memo, useEffect, VFC} from 'react';
import {BrowserRouter, Routes} from 'react-router-dom';
import {AliveScope} from 'react-activation';
import {ubcInitH5 as init} from '@baidu/med-utils/lib/ubcV2/ubc.h5';
import {random} from '@baidu/health-utils/lib/random/random';
import '@baidu/hcui/lib/style/entry';
import '@baidu/med-styles/lib/wise.css';
import {getQueryObject} from '@baidu/med-utils';
import '@/styles/reset.less';
import '@/styles/app.global.less';
import {EVENT_NAME, SERVICE_ID} from '@/dicts/ubcConfig';
import {routerHandle} from './_routes';
import globalData from './globalData';

const removePageLoading = () => {
    const loading$ = document.getElementById('loading');
    loading$ && (loading$.style.display = 'none');
};


const App: VFC = () => {
    const query = getQueryObject(window.location.href) ?? {};
    globalData.set('lid', query.lid || random(8));

    useEffect(
        removePageLoading,
        []
    );

    init(
        EVENT_NAME,
        SERVICE_ID,
        {
            appname: 'baidujiankangapp',
        },
        {
            getGlobalData() {
                return {
                    lid: globalData.get('lid'),
                    appVersion: '1.0.0',
                };
            },
            getCurrentPages() {
                // 暂无法取到页面栈，后期实现11
                return [];
            },
        }
    );

    return (
        <BrowserRouter basename={process.env.BASE_NAME}>
            <AliveScope>
                <Routes>
                    {routerHandle()}
                </Routes>
            </AliveScope>
        </BrowserRouter>
    );
};

export default memo(App);
